// sort-imports-ignore
import "instrument";
import { ApolloProvider } from "@apollo/client";
import App from "App";
import { ThemeProvider } from "contexts/ThemeContext";
import React from "react";
import "react-app-polyfill/stable";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { userClient } from "utils/jwt";

const container = document.getElementById("root") as Element;
const root = createRoot(container);

root.render(
  <BrowserRouter>
    <ThemeProvider>
      <ApolloProvider client={userClient}>
        <App />
      </ApolloProvider>
    </ThemeProvider>
  </BrowserRouter>
);
